import { createComponent } from 'react-fela'

import { breakpoints } from '../constants/theme'

const Section = props => ({
  flexDirection: props.row ? 'row' : 'column',
  minHeight: props.height,
  padding: props.padding,
  justifyContent: props.justifyContent || (props.center && 'center'),
  alignItems: props.alignItems || (props.center && 'center'),
  flex: typeof props.flex === 'boolean' ? '1 0 auto' : props.flex,
  maxWidth: '100%',
  width: props.width,
  flexWrap: props.wrap ? 'wrap' : 'nowrap',
  alignSelf: props.alignSelf || 'flex-start',
  [`@media (max-width: ${breakpoints.min768 - 1}px)`]: {
    flexDirection: props.columnOnSmall && 'column',
    alignSelf: 'center'
  },
  extend: [
    {
      condition: props.hideUntil,
      style: {
        [`@media (max-width: ${props.hideUntil - 1}px)`]: {
          display: 'none'
        }
      }
    },
    {
      condition: props.hideAt,
      style: {
        [`@media (min-width: ${props.hideAt}px)`]: {
          display: 'none'
        }
      }
    }
  ]
})

export default createComponent(Section, 'div', [
  'data-scroll-effect',
  'data-scroll-offset',
  'data-scroll-scope',
  'data-parallax-speed',
  'data-parallax-direction',
  'data-parallax-offset'
])



// WEBPACK FOOTER //
// ../components/Section.js